module.exports = __webpack_public_path__ + "img/report.d0f58097.png";